<template>
  <system-request-view v-if="userRole === 'system'"></system-request-view>
  <normal-user-request-view v-if="userRole === 'employee'"></normal-user-request-view>
  <client-request-view v-if="userRole === 'client'"></client-request-view>
</template>
<script>

import SystemRequestView from "@/views/Requests/SystemRequestView"
import NormalUserRequestView from "@/views/Requests/NormalUserRequestView"
import ClientRequestView from "@/views/Requests/ClientRequestView"

export default {
  name: "Request",
  components: {ClientRequestView, NormalUserRequestView, SystemRequestView},
  head() {
    return {
      title: "Request Overview | Heed Cyprus",
      meta: [
        {
          name: "description",
          content: "Explore details about the request.",
        },
      ]
    }
  },
  computed: {
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    }
  }
}
</script>
<style></style>
